import { breadcrumbs as Breadcrumbs } from '@shared/breadcrumbs/';

export const breadcrumbs = {
  namespaced: true,
  state: {
    current: []
  },
  actions: {
    set_current({ commit }, name) {
      const current = Breadcrumbs.getByName(name);
      if (current) {
        commit('current', current.items);
      } else {
        commit('current', []);
      }
    },
    add_item({ state, commit }, { item }) {
      const current = [...state.current, item];

      commit('current', current);
    },
    add_items({ state, commit }, { items }) {
      const current = [...state.current, ...items];
      commit('current', current);
    }
  },
  getters: {
    current: state => state.current || []
  },
  mutations: {
    current: (state, value) => (state.current = value)
  }
};
